import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Session-level cache: industries are fetched once and shared across every IndustrySelect / consumer.
// Call invalidateIndustries() after an admin edits the list.
let _cache = null;
let _promise = null;
const _subs = new Set();

async function _fetch() {
  const { data } = await api.get("/industries");
  _cache = data;
  _subs.forEach((fn) => fn(data));
  return data;
}

export function invalidateIndustries() {
  _cache = null;
  _promise = _fetch();
  return _promise;
}

export function useIndustries() {
  const [items, setItems] = useState(_cache || []);
  useEffect(() => {
    _subs.add(setItems);
    if (_cache) setItems(_cache);
    else {
      if (!_promise) _promise = _fetch();
      _promise.then((d) => setItems(d)).catch(() => {});
    }
    return () => { _subs.delete(setItems); };
  }, []);
  return items;
}

// Convenience: map of industry id -> label for display in lists/detail.
export function useIndustryLabels() {
  const items = useIndustries();
  const map = {};
  items.forEach((i) => { map[i.id] = i.label; });
  return map;
}
